import * as THREE from 'three';
import { chunkKey, getChunkBounds } from './worldGrid.js';
import { CityRegionGenerator } from './CityRegion.js';

/**
 * One streamed world chunk (visual + colliders for a fixed world XZ region).
 */
export class WorldChunk {
  /**
   * @param {number} chunkX
   * @param {number} chunkZ
   * @param {import('./ChunkManager.js').ChunkBuildContext} ctx
   */
  /**
   * @param {number} chunkX
   * @param {number} chunkZ
   * @param {import('./ChunkManager.js').ChunkBuildContext} ctx
   * @param {number} [lod=0]
   */
  constructor(chunkX, chunkZ, ctx, lod = 0) {
    this.chunkX = chunkX;
    this.chunkZ = chunkZ;
    this.lod = lod;
    this.group = new THREE.Group();
    this.group.name = `WorldChunk_${chunkX}_${chunkZ}`;
    this.bounds = getChunkBounds(chunkX, chunkZ, ctx.chunkWorldSize);
    this.colliders = [];
    this._ctx = ctx;
    this._region = null;
    this.loaded = false;
  }

  build() {
    if (this.loaded) return;
    this._region = new CityRegionGenerator({
      buildingMaterial: this._ctx.buildingMaterial,
      accentMaterial: this._ctx.accentMaterial,
      accentPoleMaterial: this._ctx.accentPoleMaterial,
      cityConfig: this._ctx.cityConfig,
      bounds: this.bounds,
      alloc: this._ctx.alloc,
      signs: this._ctx.signs,
      lod: this.lod,
      entranceRegistry: this._ctx.entranceRegistry,
      chunkKey: chunkKey(this.chunkX, this.chunkZ),
    });
    this._region.build(this.group);
    this.colliders = this._region.colliders;
    this.buildingCount = this._region.buildingCount;
    this.loaded = true;
  }

  dispose() {
    this._region?.dispose();
    this._region = null;
    this.group.clear();
    this.colliders = [];
    this.loaded = false;
  }
}
